// extracted by mini-css-extract-plugin
module.exports = {"TableCellMultiIcons":"TableCellMultiIcons-TableCellMultiIcons-c12zFG","multiIcon":"TableCellMultiIcons-multiIcon-3lRfLp","imageIcon":"TableCellMultiIcons-imageIcon-3n3UC3"};